(() => {
  function showAll(elements) {
    elements.forEach((el) => (el.style.display = ''));
  }

  function initAccordion(element) {
    const allHeadings = [...element.querySelectorAll('.elp-Accordion-heading')];
    const allContentSections = [
      ...element.querySelectorAll('.elp-Accordion-content')
    ];

    allHeadings.forEach((heading) => {
      heading.addEventListener('click', (e) => {
        let headingNode = e.currentTarget;
        let contentNode = headingNode.nextElementSibling;
        let { display: isOpen } = contentNode.style;

        showAll(allContentSections);

        contentNode.style.display = isOpen ? '' : 'block';
        headingNode.classList.toggle('is-open', !isOpen);
      });
    });
  }

  const accordions = document.querySelectorAll('.elp-Accordion');

  if (!accordions.length) {
    return;
  }

  [...accordions].forEach((accordion) => initAccordion(accordion));
})();
